import { 
  FETCH_PACKAGES,
  SET_PACKAGES_LIST,
  SET_APPLY_PROMOCODE,
  SET_SUSCRIPTION_ORDER_ID,
  SET_SUSCRIPTION_STATUS,
  SET_SUSCRIPTIONS,
  SESSION_EXPIRED,
  CLEAR_SUSCRIPTION_STATUS,
  SET_SUBSCRIPTIONS
  
} from "../../util/actionTypes.js";
import BrokerService from "../../services/broker.service";
import moment from "moment";
import { exitOrder } from "util/helper.js";
import { toast } from "components/common/custom-toast/Toast.js";

export const fetchPackages = (parma) => async (dispatch) => { 
  const res = await BrokerService.getPackageList(parma);
  try {
    
    if (res.code === 200) {
      const data = res.data; 
      if (data) {
        dispatch({
          type: SET_PACKAGES_LIST,
          payload: data?.packages,
        });
        return data;
      }
    } else if (res.code === 403) {
      dispatch({
          type: SESSION_EXPIRED,
          payload: true,
        });
      return { sessionExpired : true };
    } else {
      console.log("error response code search-option-chain instrument names");
    }
  } catch (error) {
    console.log(
      "error processing option-chain-instrument names request :",
      error
    );
  }
};

export const applyPromoCode = (parma) => async (dispatch) => { 
  const res = await BrokerService.applyPromoCode(parma);
  try {
    
    if (res.code === 200) {
      const data = res.data; 
      if (data?.isValidPromo) {
        dispatch({
          type: SET_APPLY_PROMOCODE,
          payload: data,
        });
        return data;
      } else {
        return data;
      }
    } else if (res.code === 403) {
      dispatch({
          type: SESSION_EXPIRED,
          payload: true,
        });
      return { sessionExpired : true };
    } else {
      console.log("error response code search-option-chain instrument names");
    }
  } catch (error) {
    console.log(
      "error processing option-chain-instrument names request :",
      error
    );
  }
};

export const createOrderIdAction = (parma) => async (dispatch) => { 
  const res = await BrokerService.getSuscriptionOrderId(parma);
  try {
    
    if (res.code === 200) {
      const data = res.data; 
      if (data) {
         var response = data;
          response.packageId = parma.packageId;
        dispatch({ 
          type: SET_SUSCRIPTION_ORDER_ID,
          payload: response,
        });
      }
    } else if (res.code === 403) {
      dispatch({
          type: SESSION_EXPIRED,
          payload: true,
        });
      return { sessionExpired : true };
    } else {
      console.log("error response code search-option-chain instrument names");
    }
  } catch (error) {
    console.log(
      "error processing option-chain-instrument names request :",
      error
    );
  }
};export const createStaticIPOrderIdAction = (parma) => async (dispatch) => { 
  const res = await BrokerService.purchaseStaticIP(parma);
  try {
    if (res.code === 200) {
      const data = res.data; 
      if (data) {
          var response = data;
          response.packageId = "Static IP"; 
          response.isStaticIP = true;
        dispatch({ 
          type: SET_SUSCRIPTION_ORDER_ID,
          payload: response,
        });
      }
    } else if (res.code === 403) {
      dispatch({
          type: SESSION_EXPIRED,
          payload: true,
        });
      return { sessionExpired : true };
    } else {
      toast.error(res.error || "Failed to create Static IP order");
    }
  } catch (error) {
    console.log("error processing Static IP order request :", error);
  }
};

export const createStaticIPRenewalOrderIdAction = (parma) => async (dispatch) => { 
  const res = await BrokerService.renewStaticIP(parma);
  try {
    if (res.code === 200) {
      const data = res.data; 
      if (data) {
          var response = data;
          response.packageId = "Static IP Renewal"; 
          response.isStaticIP = true;
          response.isRenewal = true;
        dispatch({ 
          type: SET_SUSCRIPTION_ORDER_ID,
          payload: response,
        });
      }
    } else if (res.code === 403) {
      dispatch({
          type: SESSION_EXPIRED,
          payload: true,
        });
      return { sessionExpired : true };
    } else {
      toast.error(res.error || "Failed to create Static IP renewal order");
    }
  } catch (error) {
    console.log("error processing Static IP renewal order request :", error);
  }
};

export const fetchUserStaticIPsAction = () => async (dispatch) => {
  const res = await BrokerService.getUserStaticIPs();
  try {
    if (res.code === 200) {
      return res.data;
    } else if (res.code === 403) {
      dispatch({
        type: SESSION_EXPIRED,
        payload: true,
      });
      return { sessionExpired: true };
    } else {
      toast.error(res.error || "Failed to fetch Static IPs");
      return null;
    }
  } catch (error) {
    console.log("error fetching Static IPs:", error);
    return null;
  }
};

export const assignStaticIPAction = (params) => async (dispatch) => {
  const res = await BrokerService.assignStaticIP(params);
  try {
    if (res.code === 200) {
      return res.data;
    } else if (res.code === 403) {
      dispatch({
        type: SESSION_EXPIRED,
        payload: true,
      });
      return { sessionExpired: true };
    } else {
      toast.error(res.error || "Failed to assign IP");
      return null;
    }
  } catch (error) {
    console.log("error assigning Static IP:", error);
    return null;
  }
};

export const unassignStaticIPAction = (params) => async (dispatch) => {
  const res = await BrokerService.unassignStaticIP(params);
  try {
    if (res.code === 200) {
      return res.data;
    } else if (res.code === 403) {
      dispatch({
        type: SESSION_EXPIRED,
        payload: true,
      });
      return { sessionExpired: true };
    } else {
      toast.error(res.error || "Failed to unassign IP");
      return null;
    }
  } catch (error) {
    console.log("error unassigning Static IP:", error);
    return null;
  }
};

export const subscriptionStatusAction = (parma) => async (dispatch) => { 
  const res = await BrokerService.getSubscriptionStatus(parma);
  try {
    
    if (res.code === 200) {
      const data = res.data; 
      if (data) {
        dispatch({
          type: SET_SUSCRIPTIONS,
          payload: data,
        });
      }
    } else if (res.code === 403) {
      dispatch({
          type: SESSION_EXPIRED,
          payload: true,
        });
      return { sessionExpired : true };
    } else {
      console.log("error response code search-option-chain instrument names");
    }
  } catch (error) {
    console.log(
      "error processing option-chain-instrument names request :",
      error
    );
  }
};

export const staticIPPaymentStatusAction = (parma, userId) => async (dispatch) => { 
    const res = await BrokerService.staticIPPaymentCallback(parma, userId);
    try {
      if (res.code === 200) {
        const data = res.data; 
        if (data) {
          dispatch({
            type: SET_SUSCRIPTIONS,
            payload: data,
          });
        }
      } else if (res.code === 403) {
        dispatch({
            type: SESSION_EXPIRED,
            payload: true,
          });
        return { sessionExpired : true };
      } else {
        toast.error(res.error || "Failed to update Static IP payment status");
      }
    } catch (error) {
        console.log("error static IP payment callback :", error);
    }
};

export const staticIPRenewalStatusAction = (parma, userId) => async (dispatch) => { 
    const res = await BrokerService.staticIPRenewalCallback(parma, userId);
    try {
      if (res.code === 200) {
        const data = res.data; 
        if (data) {
          dispatch({
            type: SET_SUSCRIPTIONS,
            payload: data,
          });
        }
      } else if (res.code === 403) {
        dispatch({
            type: SESSION_EXPIRED,
            payload: true,
          });
        return { sessionExpired : true };
      } else {
        toast.error(res.error || "Failed to update Static IP renewal status");
      }
    } catch (error) {
        console.log("error static IP renewal callback :", error);
    }
};

export const startUserTrial = async (type) => {
  const res = await BrokerService.postStartUserTrial(type);
  try {
    if (res.code === 200) {
      toast.success("Trial started successfully");
      const data = res.data;
      if (data) {
        return data;
      }
    } else if (res.code === 403) {
      return { sessionExpired: true };
    } else {
      toast.error(res.error || "Something went wrong");
    }
  } catch (error) {
    console.log("error processing  request :", error);
  }
};

export const specialSession = async (type) => {
  const res = await BrokerService.specialSession(type);
  try {
    if (res.code === 200) {
      const data = res.data;
      if (data) {
        return data;
      }
    } else if (res.code === 403) {
      return { sessionExpired: true };
    } else {
      console.log("error response ");
    }
  } catch (error) {
    console.log("error processing  request :", error);
  }
};

export const setUserSubscription = (data) => {
    return {
        type: SET_SUSCRIPTIONS,
        payload: data
    };
};

export const setSubscriptions = (subscriptions) => {
  if(subscriptions){
  const activeSubscriptions = subscriptions.filter(sub => {
    if (sub.status !== 'success') return false;
    
    if (!sub.packageEndTime) return false;
    
    if (sub.productType !== 'qt-new') return false;
    
    const endDate = moment(sub.packageEndTime);
    const now = moment();
    return endDate.isAfter(now);
  });

  
  const activePlans = activeSubscriptions.map(sub => ({
    ...sub,
    daysRemaining: Math.ceil(moment(sub.packageEndTime).diff(moment(), 'days', true))
  }));
  
  const accessiblePlans = activePlans.map(plan => plan.planName) || null;

  return {
    type: SET_SUBSCRIPTIONS,
    payload: {
      allSubscriptions: subscriptions,
      activePlans,
      accessiblePlans
    }
  };
}
};

export const clearSubscriptionStatus = () => {
    return {
        type: CLEAR_SUSCRIPTION_STATUS
    };
};

export const exitBrokerPositionsAction = async(brokerId, param) =>  {
  const res = await BrokerService.exitBrokerPositions(brokerId, param);
  try {
    if (res.code === 200) {
      const data = res.data;
      if (data) {
        return data;
      }
    } else if (res.code === 403) {
      return { sessionExpired: true };
    } else {
      toast.error(res.error || "Something went wrong");
      console.log("error response ");
    }
  } catch (error) {
    console.log("error processing  request :", error);
  }
};

export const exitBasketPositionsAction = async(basketId, param) =>  {
  const res = await BrokerService.exitBasketPositions(basketId, param);
  try {
    if (res.code === 200) {
      const data = res.data;
      if (data) {
        return data;
      }
    } else if (res.code === 403) {
      return { sessionExpired: true };
    } else {
      toast.error(res.error || "Something went wrong");
      console.log("error response ");
    }
  } catch (error) {
    console.log("error processing  request :", error);
  }
};

export const exitPositionAction = async(positionId, orderQtyExit) =>  {
  const res = await BrokerService.exitPosition(positionId, orderQtyExit);
  try {
    if (res.code === 200) {
      const data = res.data;
      if (data) {
        return data;
      }
    } else if (res.code === 403) {
      return { sessionExpired: true };
    } else {
      toast.error(res.error || "Something went wrong");
      console.log("error response ");
    }
  } catch (error) {
    console.log("error processing  request :", error);
  }
};

export const exitSelectedPositionsAction = async(brokerId, param) =>  {
  const res = await BrokerService.exitSelectedPositions(brokerId, param);
  try {
    if (res.code === 200) {
      const data = res.data;
      if (data) {
        return data;
      }
    } else if (res.code === 403) {
      return { sessionExpired: true };
    } else {
      toast.error(res.error || "Something went wrong");
      console.log("error response ");
    }
  } catch (error) {
    console.log("error processing  request :", error);
  }
};

export const createOrderIdClearAction = () => (dispatch) => {
  dispatch({
    type: "CLEAR_ORDER_ID",
    payload: null
  });
};




